var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.33333V1M4 2.33333V1M1.16667 4.33333H12.8333M1 5.696C1 4.286 1 3.58067 1.29067 3.042C1.5535 2.56154 1.96133 2.17634 2.456 1.94133C3.02667 1.66667 3.77333 1.66667 5.26667 1.66667H8.73333C10.2267 1.66667 10.9733 1.66667 11.544 1.94133C12.046 2.18267 12.4533 2.568 12.7093 3.04133C13 3.58133 13 4.28667 13 5.69667V8.97133C13 10.3813 13 11.0867 12.7093 11.6253C12.4465 12.1058 12.0387 12.491 11.544 12.726C10.9733 13 10.2267 13 8.73333 13H5.26667C3.77333 13 3.02667 13 2.456 12.7253C1.96143 12.4905 1.55361 12.1055 1.29067 11.6253C1 11.0853 1 10.38 1 8.97V5.696Z",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d2d6e1240d634d17a84b2f8bab2a1d6a.svg";
export { ForwardRef as ReactComponent };